module.exports = __webpack_public_path__ + "static/media/KMH_5074-2.d9d69911.jpg";